import React from "react";
import '../styles/partners.css';
import wellhub from "../assets/images/partners/wellhub.png";  // Caminho da imagem

const partnerInfo = {
  logo: wellhub,
  plans: [
    { name: "Basic +", description: "Cross Training" },
    { name: "Gold", description: "Small Group + Cross Training" }
  ],
};

const Partners = () => {
  return (
    <>
    <section className="partners-section" id="partners">
      <br />
      <br />
      <h2 className="partner-title">
        Nossos Parceiros
      </h2>
      <div className="partner-container">
        <div className="partner-logo">
          <img src={partnerInfo.logo} alt="Parceiro" className="partner-img" />
        </div>
        <div className="plans-container">
          {partnerInfo.plans.map((plan, index) => (
            <div key={index} className="plan">
              <div className="plan-name">{plan.name}</div>
              <div className="plan-description">{plan.description}</div>
            </div>
          ))}
        </div>
      </div>
      </section>
    </>
  );
};

export default Partners;